import { render, staticRenderFns } from "./DiscoverConfig.vue?vue&type=template&id=2d464e9e"
import script from "./DiscoverConfig.vue?vue&type=script&lang=js"
export * from "./DiscoverConfig.vue?vue&type=script&lang=js"
import style0 from "./DiscoverConfig.vue?vue&type=style&index=0&id=2d464e9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports